import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "gb-info-tarif" }

import { computed, ComputedRef, PropType } from "vue";
import { Bundle } from "@/stores/bundle";
import { Country } from "@/stores/data";

export default /*#__PURE__*/_defineComponent({
  __name: 'BundleSmallCard',
  props: {
  bundle: Bundle,
  requestedCountries: {
    type: Array as PropType<Array<Country>>,
    default: () => [],
  },
},
  setup(__props) {

const props = __props;

const bundlePath: ComputedRef<string> = computed(() => {
  if (props.requestedCountries?.length) {
    return `/bundle/${props.bundle?.id}?requestedCountries=${JSON.stringify(
      props.requestedCountries.map((c) => c.iso)
    )}`;
  } else {
    return `/bundle/${props.bundle?.id}`;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (__props.bundle)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createTextVNode(_toDisplayString(__props.bundle.dataAmountGb()) + " GB ", 1),
          _createElementVNode("span", null, _toDisplayString(__props.bundle.duration) + " days", 1)
        ]),
        _createVNode(_component_router_link, {
          class: "btn btn-by",
          to: bundlePath.value
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, "$" + _toDisplayString(__props.bundle.priceUsd()), 1),
            _createTextVNode(" Buy ")
          ]),
          _: 1
        }, 8, ["to"])
      ]))
    : _createCommentVNode("", true)
}
}

})